// Jenis input tiap key alruParams, dibaca dari nilai hasil GET.

export const OPERATOR_OPTIONS = ['==', '!=', '<', '>', '<=', '>='];

const OPERATOR_KEYS = ['op', 'guardOp'];
const LOCKED_KEYS = ['metric', 'dvstType', 'guardMetric'];
const TIMEZONE_KEYS = ['displayTz'];
const ADVANCED_KINDS = ['operator', 'locked', 'raw'];
const FALLBACK_TIMEZONES = ['UTC', 'Asia/Jakarta', 'Asia/Makassar', 'Asia/Jayapura'];

export const PARAM_HINTS = {
  debounceMin: 'Minutes the condition must last before the first notification (0 = immediately).',
  repeatMin: 'Reminder interval in minutes (0 = no reminder).',
  freshMin: 'Device data older than this many minutes is not evaluated.',
  displayTz: 'Time zone used in the notification text.',
};

export function paramKind(key, value) {
  if (OPERATOR_KEYS.includes(key)) return 'operator';
  if (LOCKED_KEYS.includes(key)) return 'locked';
  if (TIMEZONE_KEYS.includes(key)) return 'timezone';
  if (typeof value === 'number') return 'number';
  if (typeof value === 'boolean') return 'boolean';
  if (typeof value === 'string') return 'text';
  return 'raw';
}

export function paramRows(params) {
  return Object.keys(params || {}).map((key) => {
    const kind = paramKind(key, params[key]);
    return {
      key, kind, advanced: ADVANCED_KINDS.includes(kind), hint: PARAM_HINTS[key] || '',
    };
  });
}

// angka gak valid dibiarin mentah biar BE yang nolak dengan pesan jelas
export function coerceParam(kind, input) {
  if (kind === 'number') {
    const text = String(input).trim();
    return text !== '' && Number.isFinite(Number(text)) ? Number(text) : input;
  }
  if (kind === 'boolean') return input === true;
  return input;
}

// daftar zona IANA buat dropdown, current selalu dijaga biar nilai lama gak hilang
export function timezoneOptions(current) {
  const zones = typeof Intl.supportedValuesOf === 'function'
    ? Intl.supportedValuesOf('timeZone')
    : FALLBACK_TIMEZONES;
  const set = new Set(zones);
  set.add('UTC');
  if (typeof current === 'string' && current) set.add(current);
  return Array.from(set);
}

export function setParam(params, row, input) {
  return { ...params, [row.key]: coerceParam(row.kind, input) };
}
